module.exports = __webpack_public_path__ + "img/Ramiro.db0dbdb2.jpeg";